import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = { class: "text-gray-500 text-sm font-medium" }
const _hoisted_4 = { class: "text-2xl font-bold mt-2 text-gray-800" }
const _hoisted_5 = {
  key: 0,
  class: "text-sm text-gray-600 mt-1"
}
const _hoisted_6 = {
  key: 2,
  class: "col-span-full bg-white rounded-lg shadow p-6 text-center text-gray-500"
}

import { computed } from 'vue';
import type { DashboardResumenInterface } from '../interfaces/dashboardResumen.interface';




export default /*@__PURE__*/_defineComponent({
  __name: 'DashboardStatsCards',
  props: {
    data: {},
    loading: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

// ✅ Extraer los datos reales sin importar el formato
const extractedData = computed(() => {
  if (!props.data) return null;
  
  // Si tiene la propiedad 'data', extraerla (viene envuelta)
  if ('data' in props.data && typeof props.data.data === 'object') {
    return props.data.data as DashboardResumenInterface;
  }
  
  // Si no, es el objeto directo
  return props.data as DashboardResumenInterface;
});

const stats = computed(() => {
  const data = extractedData.value;
  
  if (!data) {
    return [];
  }



  return [
    {
      label: 'Total Productos',
      value: (data.totalProductos ?? 0).toLocaleString(),
      subtitle: `${data.productosBajoStock ?? 0} bajo stock`,
      icon: 'package',
      bgColor: 'bg-blue-100',
      iconColor: 'text-blue-600'
    },
    {
      label: 'Pedidos Pagados',
      value: (data.totalPedidosPagados ?? 0).toLocaleString(),
      subtitle: 'Total procesados',
      icon: 'cart',
      bgColor: 'bg-green-100',
      iconColor: 'text-green-600'
    },
    {
      label: 'Total Clientes',
      value: (data.totalClientes ?? 0).toLocaleString(),
      subtitle: 'Clientes activos',
      icon: 'users',
      bgColor: 'bg-purple-100',
      iconColor: 'text-purple-600'
    },
    {
      label: 'Ventas Hoy',
      value: `S/ ${(data.ventasHoy?.total ?? 0).toLocaleString()}`,
      subtitle: `${data.ventasHoy?.cantidad ?? 0} ventas`,
      icon: 'trending',
      bgColor: 'bg-orange-100',
      iconColor: 'text-orange-600'
    }
  ];
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.loading)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, _renderList(4, (i) => {
          return _createElementVNode("div", {
            key: i,
            class: "bg-white rounded-lg shadow p-6 animate-pulse"
          }, [...(_cache[0] || (_cache[0] = [
            _createStaticVNode("<div class=\"flex items-center justify-between\"><div class=\"flex-1\"><div class=\"h-4 bg-gray-200 rounded w-24 mb-3\"></div><div class=\"h-8 bg-gray-200 rounded w-32 mb-2\"></div><div class=\"h-3 bg-gray-200 rounded w-20\"></div></div><div class=\"w-12 h-12 bg-gray-200 rounded-full\"></div></div>", 1)
          ]))])
        }), 64))
      : (extractedData.value)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(stats.value, (stat) => {
            return (_openBlock(), _createElementBlock("div", {
              key: stat.label,
              class: "bg-white rounded-lg shadow p-6 hover:shadow-lg transition-shadow"
            }, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", null, [
                  _createElementVNode("p", _hoisted_3, _toDisplayString(stat.label), 1),
                  _createElementVNode("h3", _hoisted_4, _toDisplayString(stat.value), 1),
                  (stat.subtitle)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(stat.subtitle), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass(['w-12 h-12 rounded-full flex items-center justify-center', stat.bgColor])
                }, [
                  (stat.icon === 'package')
                    ? (_openBlock(), _createElementBlock("svg", {
                        key: 0,
                        class: _normalizeClass(['w-6 h-6', stat.iconColor]),
                        xmlns: "http://www.w3.org/2000/svg",
                        fill: "none",
                        viewBox: "0 0 24 24",
                        stroke: "currentColor"
                      }, [...(_cache[1] || (_cache[1] = [
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2",
                          d: "M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"
                        }, null, -1)
                      ]))], 2))
                    : (stat.icon === 'cart')
                      ? (_openBlock(), _createElementBlock("svg", {
                          key: 1,
                          class: _normalizeClass(['w-6 h-6', stat.iconColor]),
                          xmlns: "http://www.w3.org/2000/svg",
                          fill: "none",
                          viewBox: "0 0 24 24",
                          stroke: "currentColor"
                        }, [...(_cache[2] || (_cache[2] = [
                          _createElementVNode("path", {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-width": "2",
                            d: "M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"
                          }, null, -1)
                        ]))], 2))
                      : (stat.icon === 'users')
                        ? (_openBlock(), _createElementBlock("svg", {
                            key: 2,
                            class: _normalizeClass(['w-6 h-6', stat.iconColor]),
                            xmlns: "http://www.w3.org/2000/svg",
                            fill: "none",
                            viewBox: "0 0 24 24",
                            stroke: "currentColor"
                          }, [...(_cache[3] || (_cache[3] = [
                            _createElementVNode("path", {
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                              "stroke-width": "2",
                              d: "M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"
                            }, null, -1)
                          ]))], 2))
                        : (stat.icon === 'trending')
                          ? (_openBlock(), _createElementBlock("svg", {
                              key: 3,
                              class: _normalizeClass(['w-6 h-6', stat.iconColor]),
                              xmlns: "http://www.w3.org/2000/svg",
                              fill: "none",
                              viewBox: "0 0 24 24",
                              stroke: "currentColor"
                            }, [...(_cache[4] || (_cache[4] = [
                              _createElementVNode("path", {
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                "stroke-width": "2",
                                d: "M13 7h8m0 0v8m0-8l-8 8-4-4-6 6"
                              }, null, -1)
                            ]))], 2))
                          : _createCommentVNode("", true)
                ], 2)
              ])
            ]))
          }), 128))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [...(_cache[5] || (_cache[5] = [
            _createElementVNode("p", null, "No hay datos disponibles", -1)
          ]))]))
  ]))
}
}

})